module.exports = __webpack_public_path__ + "static/media/Home5.bc075951.jpg";